import { useQuery } from "@tanstack/react-query";
import { http } from "../../../utils";

export async function fetchVideoById(id) {
  const { data } = await http(`/admin/video/${id}`);

  return data;
}

export function useVideoById(id) {
  const { data, ...raResult } = useQuery(["video-detail", id], () =>
    fetchVideoById(id)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
